import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

/**
 * Client dédié au refresh : pas d’intercepteur sur la réponse, évite les boucles.
 */
const refreshSessionClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

let refreshPromise: Promise<string> | null = null;

/**
 * Obtient un nouvel access token via le cookie refresh (promesse partagée si appels concurrents).
 */
export function refreshAccessToken(): Promise<string> {
  if (!refreshPromise) {
    refreshPromise = refreshSessionClient
      .post<{ access_token: string }>("/auth/refresh")
      .then((res) => {
        const token = res.data.access_token;
        localStorage.setItem("token", token);
        refreshPromise = null;
        return token;
      })
      .catch((err) => {
        refreshPromise = null;
        throw err;
      });
  }
  return refreshPromise;
}

/**
 * Si aucun JWT en stockage mais cookie refresh valide, hydrate le storage.
 */
export async function trySilentRefresh(): Promise<boolean> {
  if (localStorage.getItem("token")) {
    return true;
  }
  try {
    await refreshAccessToken();
    return true;
  } catch {
    return false;
  }
}
